import axios from 'axios';

export function getLastHistoryImport({ type }) {
    if (!type) type = '360';
    return axios.post(`/last_import_date`, { type }).then((res: any) => {
        return res;
    });
}
